import i18n from 'i18next';

import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getPreviewLanguage } from 'redux/selectors/global';
import localStorageService from 'services/localStorage';
import { useQueryParams } from 'hooks/useQueryParams';
import { asyncChangeLanguage } from 'services/i18n';

const usePreviewLanguage = () => {
  const previewLanguage = useSelector(getPreviewLanguage);
  const { token } = useQueryParams() || {};

  useEffect(() => {
    if (!previewLanguage) return;

    if (!i18n.isInitialized && token) {
      localStorageService.setItem(`${token}_lang`, previewLanguage);
    } else if (i18n.isInitialized) {
      asyncChangeLanguage(previewLanguage);
    }
  }, [previewLanguage, token]);
};

export default usePreviewLanguage;
